import * as React from 'react';

/**
 * @description AppGalleryIcon icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { AppGalleryIcon } from '@sravni/design-system-icons'
 *
 * <AppGalleryIcon />
 * ```
 */
const AppGalleryIcon = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "AppGalleryIcon", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.924.996h-7.87C2.352.996 1 2.348 1 6.061v7.87c0 3.702 1.352 5.065 5.065 5.065h7.87c3.702 0 5.065-1.352 5.065-5.065V6.06C18.989 2.348 17.637.996 13.924.996Z", fill: "#C8102E" }),
    React.createElement("path", { d: "M4.558 10.098h.476v2.375h-.476v-.964H3.483v.964h-.477v-2.375h.477v.963h1.075v-.963Zm2.693 1.355c0 .381-.188.594-.532.594-.343 0-.543-.213-.543-.605v-1.344h-.477v1.355c0 .673.366 1.054 1.01 1.054.642 0 1.019-.393 1.019-1.076v-1.345H7.25v1.367Zm5.509.28-.532-1.635h-.388l-.532 1.635-.521-1.635h-.51l.82 2.375h.4l.531-1.558.532 1.558h.4l.82-2.375h-.5l-.52 1.635Zm1.873-.29h.865v-.438h-.865v-.482h1.264v-.437h-1.73v2.376h1.774v-.437h-1.308v-.583Zm1.873 1.03h.466v-2.375h-.466v2.375Zm-7.836-.504-.21.493h-.488l1.03-2.376h.422l1.03 2.376h-.498l-.211-.493H8.67Zm.177-.426h.72l-.365-.852-.355.852Z", fill: "#fff" }),
    React.createElement("path", { d: "M9.989 7.061c-1.652 0-2.993-1.355-2.993-3.025h.421c0 1.434 1.153 2.6 2.572 2.6 1.418 0 2.571-1.166 2.571-2.6h.421A3.004 3.004 0 0 1 9.99 7.061Z", fill: "#FFF" }))));

export { AppGalleryIcon };
//# sourceMappingURL=AppGalleryIcon.js.map
